




import { Vue, Component, Prop, Watch, Emit, Ref } from "vue-property-decorator";

export enum ImageSize {
  small = "0.4rem",
  middle = "1rem",
  large = "1.5rem"
}

export enum ImageType {
  circle = "50%",
  square = "0"
}

@Component
export default class IImage extends Vue {
  @Prop(String) src!: string;
  @Prop({ default: ImageSize.small }) size!: ImageSize;
  @Prop({ default: ImageType.circle }) type!: ImageType;

  style = {
    width: this.size,
    height: this.size,
    backgroundImage: `url(${this.src})`,
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
    borderRadius: this.type
  };
}
